
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[tenant]/blog/[slug]",
      function () {
        return require("private-next-pages/[tenant]/blog/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[tenant]/blog/[slug]"])
      });
    }
  